const POPULAR_MAKES_UK = ['ford', 'audi', 'mercedes_benz', 'bmw', 'volkswagen'];
const POPULAR_MAKES_FR = ['peugeot', 'volkswagen', 'audi', 'renault', 'mercedes_benz'];

export { POPULAR_MAKES_UK, POPULAR_MAKES_FR };
